export enum LinkStatus {
  Created = 'created',
  Paid = 'paid',
  Refunded = 'refunded',
}
